<div class="configuration-infomration-container">
  <h1>{{ ('view_translations.configuration' | translate) + ' "' + configurationName + '" ' + ('view_translations.has_been_added' | translate) }}</h1>
  <p>{{ 'view_translations.configuration_creation_info' | translate }}</p>
</div>
